
import { postUpdateContact } from '../api.js'

import notifications from '../notifications.js'

function _postUpdateContact(payload, dbId) {
  let promise = postUpdateContact(payload, dbId)

  promise
    .then(() => {
      notifications.pushInfo('Contact updated.')
    })
    .catch(error => {
      notifications.pushError(`Contact update failed! ${error.response.data}`, error)
    })

  return promise
}

function _init() {
  // do nothing
}

_init()

export default {
  postUpdateContact: _postUpdateContact,
}
